/**
 * @param {Function} action 
 * @param {Function} setLoading - State setter function (true/false)
 * @param {Function} onSuccess - (Optional) Success hone par kya karna hai
 */
export const handleAsyncAction = async (action, setLoading, onSuccess = null) => {
  try {
    setLoading(true);
    await action();
    if (onSuccess) onSuccess();
  } catch (error) {
    console.error("Action failed:", error);
    // also can add toast notification
  } finally {
    setLoading(false);
  }
};